import UnderLineTab from 'src/components/common/UnderLineTab'
import React, { useState } from 'react'
import { CouponDetailInfoTabSpace } from 'src/types/api'
import { PurchaseHistoryDetailPageProps } from 'src/pages/PurchaseHistoryPage/PurchaseHistoryDetailPage'
import MixedHtmlData from 'src/components/common/MixedHtmlData'
import Accordion from 'src/components/common/Accordion'
import styled from 'styled-components'
import { Container } from 'src/components/common/Container'

type PurchaseHistoryDetailUnderLineTabType = 0 | 1

const PurchaseHistoryDetailUnderLineTab = ({
  couponDetailTabData,
  Introduction,
}: Pick<PurchaseHistoryDetailPageProps, 'Introduction' | 'couponDetailTabData'>) => {
  const { PurchasePolicy, RefundPolicy, CouponInfo, SellerInfo } =
    couponDetailTabData as CouponDetailInfoTabSpace.Response

  const [activeTab, setActiveTab] = useState<PurchaseHistoryDetailUnderLineTabType>(0)

  const UsageContents = () => (
    <S.PurchaseHistoryUsageWrap>
      <MixedHtmlData html={Introduction as string} />
    </S.PurchaseHistoryUsageWrap>
  )

  const DetailInfoContents = () => (
    <React.Fragment>
      <Accordion {...CouponInfo} type="big" />
      <Accordion {...RefundPolicy} type="big" />
      <Accordion {...PurchasePolicy} type="big" />
      <Accordion {...SellerInfo} type="big" />
    </React.Fragment>
  )

  return (
    <UnderLineTab<PurchaseHistoryDetailUnderLineTabType>
      items={[
        { text: '이용안내', contents: <UsageContents />, value: 0 },
        { text: '상세정보', contents: <DetailInfoContents />, value: 1 },
      ]}
      state={{ activeTab, setActiveTab }}
    />
  )
}
export default PurchaseHistoryDetailUnderLineTab

const S = {
  PurchaseHistoryUsageWrap: styled(Container)`
    padding: 20px;
  `,
}
